import { zSchema } from "@zeal/common";

export const getSshKeyRotationPublicKeyResponseSchema = zSchema.object({
  id: zSchema.string(),
  state_code: zSchema.string(),
  key_version: zSchema.number(),
  public_key: zSchema.string(),
});

export type TGetSshKeyRotationPublicKeyResponseSchema = zSchema.infer<
  typeof getSshKeyRotationPublicKeyResponseSchema
>;
